/* @flow */
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

import { updateUserInfo, logEvent } from '../../utils/analytics';
import { getAllTodos } from '../todo/actions';
import { isLoggedInSelector } from './selectors';
import lysterClient from '../../clients/lyster-client';


type Input = {
  email: string,
  password: string
};

export const completedGettingStartedGuide = () => (dispatch: Dispatch) => {
  logEvent('tutorial_complete');
  dispatch({ type: 'COMPLETED_GETTING_STARTED_GUIDE' });
};

export const setToken = (token: string) => async (dispatch: Dispatch) => {
  updateUserInfo(token);

  dispatch({ type: 'LOGUP_SUCCEEDED', payload: { token } });
  dispatch(getAllTodos(false));
};

export const useSetToken = () => {
  const dispatch = useDispatch(),
        callback = useCallback((token: String) => dispatch(setToken(token)), []) //eslint-disable-line

  return callback;
};

export const logup = ({ email, password }: Input) => async (dispatch: Dispatch) => {
  dispatch({ type: 'LOGUP_REQUEST' });
  try {
    const { data: { token } } = await lysterClient.post('/auth/logup', { email, password });

    updateUserInfo(token);

    dispatch({ type: 'LOGUP_SUCCEEDED', payload: { token } });
    dispatch(getAllTodos(false));
  } catch (error) {
    dispatch({
      type: 'LOGUP_FAILED',
      payload: {
        error: error.response ? error.response.data : error,
      },
    });
    throw error;
  }
};

export const renew = () => async (dispatch: Dispatch) => {
  dispatch({ type: 'AUTH_RENEW_REQUESTED' });
  try {
    const { data: { token } } = await lysterClient.post('/auth/renew');

    dispatch({ type: 'AUTH_RENEW_SUCCEEDED', payload: { token } });
  } catch (error) {
    dispatch({ type: 'AUTH_RENEW_FAILED', payload: { error } });
  }
};

export const logout = () => (dispatch: Dispatch, getState: () => Object) => {
  updateUserInfo();
  if (isLoggedInSelector(getState())) {
    dispatch({ type: 'LOGOUT_REQUEST' });
  }
};
